/**
 * Admin Redemption Approval Component
 *
 * Allows master admin to review and approve/reject pending redemption requests
 */

Vue.component('admin-redemption-approval', {
    template: templates.adminRedemptionApproval,
    data() {
        return {
            model: {
                pendingRequests: [],
                stats: {
                    requests_by_status: {},
                    total_points_redeemed: 0,
                    popular_items: []
                },
                loading: false,
                error: null,
                selectedRequest: null,
                rejectionReason: '',
                showRejectModal: false,
                processingRequestId: null
            }
        };
    },
    computed: {
        pendingCount() {
            return this.model.pendingRequests.length;
        },
        approvedCount() {
            return this.model.stats.requests_by_status['approved'] || 0;
        },
        rejectedCount() {
            return this.model.stats.requests_by_status['rejected'] || 0;
        }
    },
    mounted() {
        const c = this;
        c.loadData();
    },
    methods: {
        loadData() {
            const c = this;
            c.model.loading = true;
            c.model.error = null;

            Promise.all([
                c.loadPendingRequests(),
                c.loadStats()
            ])
                .then(() => {
                    c.model.loading = false;
                })
                .catch((error) => {
                    c.model.loading = false;
                    c.model.error = 'Failed to load data: ' + error.message;
                    console.error('Load data error:', error);
                });
        },

        loadPendingRequests() {
            const c = this;
            return redemptionService.getPendingRequests('pending')
                .then((response) => {
                    c.model.pendingRequests = response.data.requests;
                })
                .catch((error) => {
                    console.error('Failed to load pending requests:', error);
                    throw error;
                });
        },

        loadStats() {
            const c = this;
            return redemptionService.getStats()
                .then((response) => {
                    c.model.stats = response.data.stats;
                })
                .catch((error) => {
                    console.error('Failed to load stats:', error);
                    throw error;
                });
        },

        approveRequest(request) {
            const c = this;

            const confirmMsg = `Approve redemption for ${request.twitchDisplayName}?\n\nItem: ${request.item_name}\nCost: ${request.point_cost} points\n\nThis will:\n- Deduct ${request.point_cost} points from user\n- Grant the item to the user\n- Cannot be undone`;

            if (!confirm(confirmMsg)) {
                return;
            }

            c.model.processingRequestId = request.request_id;

            redemptionService.approveRequest(request.request_id)
                .then((response) => {
                    if (response.data.success) {
                        alert('Redemption approved successfully!');
                        c.loadData(); // Reload data
                    } else {
                        alert('Failed to approve: ' + response.data.message);
                    }
                })
                .catch((error) => {
                    console.error('Approval error:', error);
                    alert('Failed to approve redemption: ' + (error.response?.data?.message || error.message));
                })
                .finally(() => {
                    c.model.processingRequestId = null;
                });
        },

        openRejectModal(request) {
            const c = this;
            c.model.selectedRequest = request;
            c.model.rejectionReason = '';
            c.model.showRejectModal = true;
        },

        closeRejectModal() {
            const c = this;
            c.model.showRejectModal = false;
            c.model.selectedRequest = null;
            c.model.rejectionReason = '';
        },

        confirmReject() {
            const c = this;

            if (!c.model.rejectionReason.trim()) {
                alert('Please provide a reason for rejection');
                return;
            }

            c.model.processingRequestId = c.model.selectedRequest.request_id;

            redemptionService.rejectRequest(c.model.selectedRequest.request_id, c.model.rejectionReason)
                .then((response) => {
                    if (response.data.success) {
                        alert('Redemption rejected');
                        c.closeRejectModal();
                        c.loadData(); // Reload data
                    } else {
                        alert('Failed to reject: ' + response.data.message);
                    }
                })
                .catch((error) => {
                    console.error('Rejection error:', error);
                    alert('Failed to reject redemption: ' + (error.response?.data?.message || error.message));
                })
                .finally(() => {
                    c.model.processingRequestId = null;
                });
        },

        formatDate(dateString) {
            if (!dateString) return 'N/A';
            const date = new Date(dateString);
            return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
        },

        getItemTypeLabel(itemType) {
            const labels = {
                'frame': 'Frame',
                'background': 'Background',
                'event_card': 'Event Card',
                'subscription': 'Subscription'
            };
            return labels[itemType] || itemType;
        },

        getItemTypeIcon(itemType) {
            const icons = {
                'frame': '🖼️',
                'background': '🌄',
                'event_card': '🃏',
                'subscription': '⭐'
            };
            return icons[itemType] || '🎁';
        },

        hasEnoughPoints(request) {
            return request.user_current_points >= request.point_cost;
        }
    }
});
